export default __webpack_public_path__ + "static/media/Image From ET__UI.babde09f.png";